import React from "react";
import { Skeleton, Stack } from "@mui/material";

const MyOrderPaymentSkeleton = () => {
  return (
    <Stack spacing={2} className="payment-information">
      <div className="title">Payment Information</div>
      <div className="content">
        <div
          className="order-payment-type"
          style={{
            width: "100%",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Skeleton animation="wave" width="50%" />
        </div>

        <div className="product-list">
          <div className="product-name-and-qty" style={{ width: "100%" }}>
            <Skeleton animation="wave" width="50%" />
          </div>
          <div className="product-price">
            <Skeleton animation="wave" width="50px" />
          </div>
        </div>

        <div className="sub-total-price column-item">
          <div className="label">Sub Total Price</div>
          <div className="price">
            <Skeleton animation="wave" width="50px" />
          </div>
        </div>
        <div className="discount-price column-item">
          <div className="label">Discounted Price</div>
          <div className="price">
            <Skeleton animation="wave" width="50px" />
          </div>
        </div>

        <div className="coupon-discount-price column-item">
          <div className="label">Coupon Discounted Price</div>
          <div className="price">
            <Skeleton animation="wave" width="50px" />
          </div>
        </div>

        <div className="shipping-price column-item">
          <div className="label">Shipping</div>
          <div className="price">Free</div>
        </div>
        <div className="total-price column-item">
          <div className="label">Total Price</div>
          <div className="price">
            <Skeleton animation="wave" width="50px" />
          </div>
        </div>
      </div>
    </Stack>
  );
};

export default MyOrderPaymentSkeleton;
